import { RespondentType } from '../../models/questions';
import { arePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet } from '../../selectors/postCheckoutMandatoryQuestions/arePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet';
import { CheckoutState } from '../../state';
import { getSurveyType } from '../event';
import { hasPrepaymentQuestions } from './pureSelectors';

export const areAsyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    (!hasPrepaymentQuestions(state) &&
        [RespondentType.buyer, RespondentType.direct].includes(
            getSurveyType(state),
        )) ||
    arePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet(state);
